import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\components\\CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\components\\TranslationProvider.tsx");
;
import(/* webpackMode: "eager" */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\styles\\index.css");
